import {
  getApiErrorMessage,
  isApiPayloadSuccess,
  readApiResponseBody,
} from 'src/marketConnect/helpers/crud-helper/helpers'

export const getRefreshMappingSuccessMessage = (response: unknown): string => {
  const body = readApiResponseBody(response)
  return body?.message || body?.massage || 'Mapping refreshed successfully'
}

export const getRefreshMappingErrorMessage = (error: unknown): string =>
  getApiErrorMessage(error, 'Mapping refresh failed')

export {isApiPayloadSuccess}
